import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { get } from 'lodash';
import { getDisplayName } from 'helpers/component';

export default function ProtectedComponentEnhancer({
    store: storeKey = 'store',
    requiredCapabilities = [],
    alwaysRender = false,
    onRenderProps = null,
    NoAccessComponent = null,
} = {}) {
    return function ProtectedComponentHOC(WrappedComponent) {
        class ProtectedComponent extends React.Component {
            constructor(props, context) {
                super(props);
                this.store = context[storeKey];
            }

            render() {
                const userScope = get(this.props, ['currentUser', 'scope'], []);

                let check = false;

                // If requiredCapabilities given
                if (requiredCapabilities.length) {
                    // require each to exist with the user
                    check = requiredCapabilities.every(capability => userScope.includes(capability));
                } else {
                    // otherwise, require the user to simply exist
                    check = Boolean(this.props.currentUser);
                }

                let componentProps = this.props;
                if (onRenderProps) {
                    componentProps = onRenderProps({
                        props: this.props,
                        check
                    });
                }

                if (alwaysRender || check) {
                    return <WrappedComponent {...componentProps} />;
                }

                if (NoAccessComponent) {
                    return <NoAccessComponent {...componentProps} />;
                }

                return null;
            }
        }

        ProtectedComponent.contextTypes = {
            [storeKey]: PropTypes.object
        };

        ProtectedComponent.displayName = `ProtectedComponent(${getDisplayName(WrappedComponent)})`;

        const mapStateToProps = state => ({
            currentUser: state.users.currentUser
        });

        return connect(mapStateToProps)(ProtectedComponent);
    };
}



// WEBPACK FOOTER //
// ./src/hoc/ProtectedComponent.js